import type { Sticker } from '../types';

export const photography: Sticker[] = [
  {
    id: 23001,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/001-photography.png',
    name: 'Aparat',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23002,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/002-photography.png',
    name: 'Zdjęcie',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23003,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/003-photography.png',
    name: 'Obiektyw',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23004,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/004-photography.png',
    name: 'Studio',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23005,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/005-photography.png',
    name: 'Lampa Błyskowa',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23006,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/006-photography.png',
    name: 'Album',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23007,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/007-photography.png',
    name: 'Statyw',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23008,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/008-photography.png',
    name: 'Fotograf',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23009,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/009-photography.png',
    name: 'Galeria',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23010,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/010-photography.png',
    name: 'Edycja',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23011,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/011-photography.png',
    name: 'Filtr',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23012,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/012-photography.png',
    name: 'Kadrowanie',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23013,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/013-photography.png',
    name: 'Portfolio',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23014,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/014-photography.png',
    name: 'Sesja',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23015,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/015-photography.png',
    name: 'Plener',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23016,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/016-photography.png',
    name: 'Kompozycja',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23017,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/017-photography.png',
    name: 'Oświetlenie',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23018,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/018-photography.png',
    name: 'Retusz',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23019,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/019-photography.png',
    name: 'Ekspozycja',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  },
  {
    id: 23020,
    url: 'https://stickers.nauczniaczek.pl/colections/14619380-photography/png/020-photography.png',
    name: 'Migawka',
    category: 'photography',
    author: 'Flaticon',
    license: 'Flaticon Premium'
  }
];